import {inject, Injectable} from '@angular/core';
import {from, Observable} from 'rxjs';
import {FvPhysicalPaymentsBridgeService} from '@discocil/fv-angular-physical-payments-bridge';

export interface CardReaderConfig {
  isConnected: boolean;
  deviceName: string;
}

export interface AuthenticateDeviceParams {
  baseUrl: string;
  secret: string;
}

export interface ExecuteTapToPayParams {
  secret: string;
  baseUrl: string;
  useCardReader: boolean;
}

@Injectable({providedIn: 'root'})
export class PaymentHardwareBridge {
  private readonly bridge = inject(FvPhysicalPaymentsBridgeService);

  openCardReaderConfig(): Observable<CardReaderConfig> {
    return from(this.bridge.openCardReaderConfig());
  }

  authenticateDevice(params: AuthenticateDeviceParams): Observable<void> {
    return from(this.bridge.authenticateDevice(params));
  }

  getInstallationId(): Observable<string> {
    return from(this.bridge.getInstallationId());
  }

  execute(params: ExecuteTapToPayParams): Observable<void> {
    return from(this.bridge.executeTapToPayPayment(params));
  }
}
